
import { Bounce, Power0, Power1, Power2, Power3, Power4, Back, gsap } from 'gsap';

import { BitmapCountUp } from "../../component/BitmapCountUp";
import { FontStyle, FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { Helper } from "../../../dev/utils/Helper";
import { IDimOrientation, LayoutDimData, ResizeHelper } from "../../../dev/utils/ResizeHelper";
import { MathHelper } from "../../../dev/utils/MathHelper";

import { BitmapTextStyleOptions, TextStyleOptions } from "../../../dev/setting/text/IText";
import { StageLayer } from "@nolimitcity/slot-launcher/bin/StageLayer";
import { GameAssets } from "../../config/texture/GameAssets";
import { TranslationTexts } from "../../config/translate/TranslationTexts";
import { Translator } from "../../../dev/setting/Translator"
import { Sequence } from '../../../dev/displayobject/Sequence';
import { BLEND_MODES, TextureMatrix } from 'pixi.js';
import { SpinePlayer } from '../../../dev/displayobject/SpinePlayer';
import { AnimationEffects } from '../../../dev/effects/AnimationEffects';
import { RoadRage } from '../../RoadRage';

export class RoadRageCounter extends PIXI.Container implements StageLayer {

    private win_FX_Spine: SpinePlayer;


    protected readonly counterDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(350, 240),
        },
        portrait: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(350, 240)
        }
    };

    public get dim(): LayoutDimData { return ResizeHelper.calcDim(this.counterDim); };

    private readonly _style_low: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP_LOW,
        fontSize: 68,
        letterSpacing: 12
    };

    private readonly _styleWays: TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 7.5,
        fill: "white",
        fontFamily: "Helvetica",
        fontSize: 52,
        fontStyle: "italic",
        fontWeight: "bold",
        miterLimit: 0,
        strokeThickness: 3
    };

    private win_FX: Sequence;
    protected _countUp: BitmapCountUp;
    protected _waysTxt: PIXI.Text;

    protected _timeline: gsap.core.Timeline;
    protected bounceTl: gsap.core.Timeline;

    private downDistance: number = 220;
    private waysYOffset: number = 190;
    
    public get timeRemaining(): number {
        return this._timeline && this._timeline.isActive() ? this._timeline.duration() - this._timeline.totalTime() : 0;
    }

    private set waysText(value: number) {
        this._waysTxt.text = value.toString() + " " + Translator.translate((value == 1 ? TranslationTexts.WAY_WON : TranslationTexts.WAYS_WON));
        this._waysTxt.updateTransform();
    }

    constructor() {
        super();
        this.name = "counter";
        this.init();
    }

    protected init(): void {

        this.win_FX = this.addChild(new Sequence({texturePath:"Win_FX"}));
        this.win_FX.anchor.set(0.5,0.5);
        this.win_FX.blendMode = BLEND_MODES.ADD;
        this.win_FX.position.y = 80;

        this.win_FX_Spine = this.addChild(new SpinePlayer("Win_FX_spine",false));
        this.win_FX_Spine.scale.set(2);
        this.win_FX_Spine.y = 70;

        this._waysTxt = this.addChild(new PIXI.Text(""));
        this._waysTxt.alpha = 0;
        this._waysTxt.style = this._styleWays;
        this._waysTxt.anchor.set(0.5, 0.5);
        this._waysTxt.position.set(0, 180);

        this._countUp = this.addChild(new BitmapCountUp(this._style_low));
        this._countUp.alpha = 0;
        this._countUp.anchor = new PIXI.Point(0.5, 0.5);

        this.onResize();
    }

    public smoke(): void {
        this.win_FX.play();
        gsap.fromTo(this.win_FX.scale,{x:.8,y:.8},{x:4,y:4,duration:this.win_FX.totalDuration/2})
    }

    public playBigWin(from: number, to: number, duration: number, ways: number = 1): gsap.core.Timeline {
        this._timeline = Helper.setTimeline(this._timeline!, new gsap.core.Timeline({ onComplete: () => this.countUpAnimVal(to) }));

        const deciNumber: number = MathHelper.floorToDecimals(to, 2);
        this._timeline.add(this._countUp.getCountUpAnimation(from, deciNumber, { duration: duration, ease:Power1.easeOut }), 0);

        if (from == 0) {
            this._timeline.fromTo(this._countUp, { alpha: 0 }, { duration: duration * 0.8, alpha: 1, ease:Power1.easeOut }, 0);
            if (duration){
                this._timeline.fromTo(this._countUp.scale, { x: 0.78, y: 0.78 }, { x: 1, y: 1, duration: duration-1, ease:Power1.easeOut }, 0);
            }
        }
        else{
            this._countUp.alpha = 1;
        } 
        this._timeline.add(
            AnimationEffects.Shake({
                x: 1.5,
                y: 1.5,
                obj: this._countUp,
                hertz: 80,
                duration: 0.5,
                updateOnComplete:true,
                positionCb:() => new PIXI.Point(0),
                Intensity: 2.75,
                ease: Power2.easeOut
            }).play()
        ,"-=0.5");
        this._timeline.to(this._countUp.scale, { x: 0.78, y: 0.78, duration: 1, ease:Power3.easeIn }, "-=1");

        this.waysText = ways;

        return this._timeline;
    }

    public play(from: number, to: number, duration: number, ways: number = 1): gsap.core.Timeline {
        this._timeline = Helper.setTimeline(this._timeline!, new gsap.core.Timeline({ onComplete: () => this.countUpAnimVal(to) }));

        const deciNumber: number = MathHelper.floorToDecimals(to, 2);
        this._timeline.add(this._countUp.getCountUpAnimation(from, deciNumber, { duration: duration, ease: Power2.easeIn  }), 0);

        if (from == 0) {
            this._timeline.fromTo(this._countUp, { alpha: 0 }, { duration: duration * 0.8, alpha: 1 }, 0);
            if (duration)
                this._timeline.fromTo(this._countUp.scale, { x: 0.88, y: 0.88 }, { x: 1, y: 1, duration: duration, ease: Power2.easeIn }, 0);
        }
        else this._countUp.alpha = 1;

        this.waysText = ways;

        return this._timeline;
    }

    private countUpAnimVal(val: number): void {
        this._countUp.showValue(val);
    }

    public setValue(val: number, ways: number): void {
        this._countUp.showValue(val);
        this._countUp.alpha = this._waysTxt.alpha = 1;
        this.waysText = ways;
    }

    private waysTL: gsap.core.Timeline;
    public showWays(duration: number = 0.65): void {
        this.waysTL = Helper.setTimeline(this.waysTL, new gsap.core.Timeline(), true);
        this.waysTL.fromTo(this._waysTxt, { alpha: 0 }, { alpha: 1, duration: duration }, 0)
        this.waysTL.fromTo(this._waysTxt, { y: this.waysYOffset - 40 }, { y: this.waysYOffset, duration: duration, ease: Back.easeOut }, 0)
    }

    public bounceHit(intencity: number = 0, durr: number = 0.2): gsap.core.Timeline {
        this.bounceTl = Helper.setTimeline(this.bounceTl, new gsap.core.Timeline());
        if (!intencity) return this.bounceTl;

        if(intencity > 0){
            this.win_FX_Spine.play({animation:["Win_Small", "Win_Medium", "Win_Large"][Math.min(intencity-1,2)]});
        }

        // if(intencity === 3) this.smoke();
        intencity = Math.min(intencity, 6);
        const inc: number = intencity * 0.05;

        this.bounceTl.to(this._countUp.scale, { duration: durr / 2, x: 1.15 + inc, y: 1.15 + inc }, 0);
        this.bounceTl.to(this._countUp.scale, { duration: durr, x: 1, y: 1, ease: Bounce.easeOut }, durr / 2);

        return this.bounceTl;
    }

    private movementTL: gsap.core.Timeline;

    public moveUp(scaling: boolean = true, duration: number = 0.35, instant: boolean): gsap.core.Timeline {
        this.onResize();
        const distYTravel: number = instant ? 30 : this.downDistance;
        const scaleSize: number = instant ? 0.90 : 0.65;

        const animatedEase: any = instant ? Bounce.easeOut : Back.easeOut;
        this.movementTL = Helper.setTimeline(this.movementTL, new gsap.core.Timeline());

        if (scaling) this.movementTL.fromTo(this.scale, { x: scaleSize, y: scaleSize }, { x: this.dim.scale.x, y: this.dim.scale.y, duration: duration, ease: animatedEase })
        return this.movementTL.fromTo(this.position, { y: this.dim.position.y + distYTravel }, { y: this.dim.position.y, duration: duration, ease: animatedEase });
    }

    public moveDown(scaling: boolean = true, duration: number = 0.5): gsap.core.Timeline {
        this.movementTL = Helper.setTimeline(this.movementTL, new gsap.core.Timeline());

        if (scaling) this.movementTL.to(this.scale, { x: "-=" + 0.27, y: "-=" + 0.27, duration: duration })
        return this.movementTL.to(this.position, { y: "+=" + this.downDistance, duration: duration, ease: Back.easeIn });
    }

    public fadeOutBreak(scaling: boolean = true, duration: number = 0.5): gsap.core.Timeline {
        this.movementTL = Helper.setTimeline(this.movementTL, new gsap.core.Timeline());
        return this.movementTL.to(this, { alpha:0,duration:duration});
    }

    public moveToReset(durr: number): gsap.core.Timeline {
        this.movementTL = Helper.setTimeline(this.movementTL, new gsap.core.Timeline());

        this.movementTL.to(this.scale, { x: this.dim.scale.x, y: this.dim.scale.y, duration: durr },0)
        return this.movementTL.to(this.position, { y: this.dim.position.y, x: this.dim.position.x, duration: durr, ease: Power3.easeOut},0);
    }

    public stop(endValue?: number, duration: number = 0.5, delay: number = 1, useLastAlpha: boolean = false): gsap.core.Timeline {
        this._timeline = Helper.setTimeline(this._timeline!, new gsap.core.Timeline());
        this.waysTL = Helper.setTimeline(this.waysTL);

        if (this._countUp.alpha == 0) return this._timeline;
        if (endValue) this._countUp.showValue(endValue);

        let startAlpha: number = useLastAlpha ? this._countUp.alpha : 1;
        let startAlphaWays: number = useLastAlpha ? this._waysTxt.alpha : 1;

        this._timeline.fromTo(this._countUp, { alpha: startAlpha }, { delay: delay, duration: duration, alpha: 0 }, 0);
        this._timeline.fromTo(this._waysTxt, { alpha: startAlphaWays }, { delay: delay, duration: duration, alpha: 0 }, 0);
        this._timeline.play(0.001);
        return this._timeline;
    }

    public onResize(): void {
        this.position = this.dim.position;
        this.scale = this.dim.scale;
    }
}
